import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { FeedbackModalAlert } from './FeedbackModalAlert';
import { FeedbackModalForm } from './FeedbackModalForm';
import { trackCloseFeedbackForm } from '../../../tracking';
import { IFeedbackDataRequest, IFeedbackDataResponseSchema } from '../../../types';

export interface IFeedbackModalProps {
  open: boolean;
  onModalClose(): void;
  sendFeedbackAction(params: IFeedbackDataRequest): Promise<IFeedbackDataResponseSchema>;
}

export interface IFeedbackModalState {
  isSuccessAlertShown: boolean;
}

export class FeedbackModal extends React.Component<IFeedbackModalProps, IFeedbackModalState> {
  public constructor(props: IFeedbackModalProps) {
    super(props);

    this.state = {
      isSuccessAlertShown: false,
    };
  }

  public render() {
    const { open, sendFeedbackAction } = this.props;
    const { isSuccessAlertShown } = this.state;

    return (
      <ModalWindow open={open} onClose={this.onModalClose}>
        {isSuccessAlertShown ? (
          <FeedbackModalAlert />
        ) : (
          <FeedbackModalForm sendFeedbackAction={sendFeedbackAction} showSuccessAlert={this.showSuccessAlert} />
        )}
      </ModalWindow>
    );
  }

  private showSuccessAlert = () => {
    this.setState({
      isSuccessAlertShown: true,
    });
  };

  private onModalClose = () => {
    this.props.onModalClose();

    if (!this.state.isSuccessAlertShown) {
      trackCloseFeedbackForm();
    }

    this.setState({
      isSuccessAlertShown: false,
    });
  };
}
